/**
 * @generated SignedSource<<2e67609a5df24933a3ed85a46a6a95a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type articlePaywallContainerArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "articlePaywallContainerArticle";
};
export type articlePaywallContainerArticle$key = {
  readonly " $data"?: articlePaywallContainerArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"articlePaywallContainerArticle">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "articlePaywallContainerArticle",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "entityId",
      "storageKey": null
    }
  ],
  "type": "Article",
  "abstractKey": null
};

(node as any).hash = "e957103770f73f665609f95e037f51ed";

export default node;
